import { hashString } from './hashString';

// Creates a unique BEM-style `className` based on the supplied arguments.
export const createUniqueClassName = (block: string, elementName: string) => {
  const hash = hashString('design-system' + block + elementName);
  return `${block}__${elementName}-${hash}`;
};
